import React from 'react'
import { useTranslation } from 'react-i18next'
import Error404 from '../../assets/svg/Error404.svg'
import { Box, Button, Grid, Link, Paper, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'

export const NotFound: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory<any>()
  const errorMessage = history?.location?.state?.response?.data?.Error

  return (
    <Grid container flexWrap='wrap' flexDirection='column' justifyContent='center' alignItems='center' m={1}>
      <Grid item>
        <Error404
          style={{
            fill: '#727171' // assets/styles/ui.less @inputBorderColor
          }}
        />
      </Grid>
      <Grid item>
        <Paper sx={{ p: 3 }} variant='outlined' elevation={0}>
          <Grid item>
            <Typography sx={{ mb: 1 }} variant='h5'>
              {t('global.something_went_wrong')}
            </Typography>

            {errorMessage ? (
              <Typography
                data-testid='errorMessage'
                variant='body2'
                sx={theme => ({ color: theme.palette.error.main, mb: 1, fontWeight: '900' })}
              >
                {t(`Error.MainProblem`)} {t(`Error.API.${errorMessage}`)}
              </Typography>
            ) : (
              <Typography data-testid='exclamation' variant='body2' color='text.secondary'>
                {t(`Error.Exclamation`)}
              </Typography>
            )}
            <Typography sx={{ mb: 1 }} variant='body2' color='text.secondary'>
              {t(`Error.Redirect`)}
            </Typography>
          </Grid>
          <Grid item sx={{ width: '100%', display: 'flex', justifyContent: 'space-evenly', mb: 4, mt: 2 }}>
            <Button
              variant='contained'
              sx={{ width: '40%' }}
              onClick={() => {
                history.goBack()
              }}
            >
              {t(`Error.PreviousPage`)}
            </Button>
            <Button
              onClick={() => {
                history.push('/')
              }}
              variant='contained'
              sx={{ width: '40%' }}
            >
              {t(`Account.Dashboard`)}
            </Button>
          </Grid>
          <Box>
            <Typography variant='body2' color='text.secondary'>
              {t(`Error.Helper`)}
              <Link sx={{ pl: 0.5, display: 'inline' }} variant='body2' href='/contact' underline='none'>
                {t(`Contact.Title`)}.
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  )
}
